import { render } from "./GalleryDetail.vue?vue&type=template&id=69baace0&scoped=true"
import script from "./GalleryDetail.vue?vue&type=script&lang=js"
export * from "./GalleryDetail.vue?vue&type=script&lang=js"

import "./GalleryDetail.vue?vue&type=style&index=0&id=69baace0&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69baace0"]])

export default __exports__